export default __webpack_public_path__ + "static/media/undraw_feeling_blue.4eac6718.svg";